import React, { useState, useRef, useEffect } from "react";

import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import CustomerView from "../GraphDashboard/Views/CustomerView";
import ProductView from "../GraphDashboard/Views/ProductView";
import RsmView from "../GraphDashboard/Views/RsmView";

import { LABELS } from "common/lables";
import { DateFunctions } from "common//datefunctions";

const GraphDashboard = () => {
  const viewRef: any = useRef(null);

  const [loading, setLoading] = useState(false);

  const [views, setViews] = useState<any>([
    {
      id: "Secondary Sales",
      label: "Secondary Sales",
    },
    {
      id: "Product Hierarchy",
      label: "Product Hierarchy",
    },
    {
      id: "Marketing Team Hierarchy",
      label: "Marketing Team Hierarchy",
    },
  ]);
  const [view, setView] = useState("Secondary Sales");

  // useEffect(() => {
  //   document.querySelector("div#root>div").classList.add("graphDashboardBg");
  //   return () => {
  //     if (document.querySelector("div#root>div")) {
  //       document
  //         .querySelector("div#root>div")
  //         .classList.remove("graphDashboardBg");
  //     }
  //   };
  // }, []);

  const getViews = (e, f) => {
    if (!f.id) {
      setView(null);
    }
    setView(f.id);
  };

  useEffect(() => {
    setLoading(false);
  });

  return loading ? (
    <div
      style={{
        display: "flex",
        backgroundColor: "#f2f2f2",
        gap: "15px",
        padding: "10px 10px",
      }}
    >
      <SkeletonBox
        height={40}
        width={"40%"}
        style={{ borderRadius: 5, marginTop: 25 }}
      />
      <SkeletonBox
        height={40}
        width={"10%"}
        style={{ borderRadius: 5, marginTop: 25 }}
      />
      <SkeletonBox
        height={40}
        width={"10%"}
        style={{ borderRadius: 5, marginTop: 25 }}
      />
    </div>
  ) : (
    <>
      <div
        style={{
          display: "flex",
          backgroundColor: "#f2f2f2",
          gap: "15px",
          padding: "10px 10px",
        }}
      >
        <div className="formGroup width30" style={{ paddingLeft: "1rem" }}>
          <label>{LABELS.VIEW}</label>
          <AutoComplete
            list={views}
            childRef={viewRef}
            defaultValue={view}
            placeholder={"Select View"}
            onChange={(e, f) => getViews(e, f)}
          />
        </div>
        <div>
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.FROM_DATE}
          </label>
          <TxtBox
            type={"date"}
            id="fromDt"
            defaultValue={DateFunctions.getDate("today", "from", "YYYY-MM-DD")}
          />
        </div>

        <div>
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.TO_DATE}
          </label>
          <TxtBox
            type={"date"}
            id="toDt"
            defaultValue={DateFunctions.getDate(
              "thismonth",
              "to",
              "YYYY-MM-DD"
            )}
          />
        </div>
      </div>

      {view === "Secondary Sales" && <CustomerView />}
      {view === "Product Hierarchy" && <ProductView />}
      {view === "Marketing Team Hierarchy" && <RsmView />}
    </>
  );
};

export default GraphDashboard;
